/**
 * Whether or not the device is a Touch device
 * @type {boolean}
 */
export const isTouchDevice = "ontouchstart" in document;
